<template>
  <div class="col-lg-3 col-md-4 search_filters">
    <div class="card"
      :style="[styles]"
    >
      <div class="card-header py-2 px-0 bd-none width--100per">
        <h2 class="t-600 t-regular"
          v-tooltip="'Refine your results using our filters'"
        >
          Filters & Analytics
          <i v-if="!isFilterLoaded" class="fa fa-spinner fa-spin t-blue t-xxs mt-1" />
        </h2>
      </div>

      <!-- render filters once search is first time loaded -->
      <div
        class="scrollable py-0 px-0"
        :class="!isFilterLoaded && disableFilters ? 'disable-content' : ''"
        ref="scrollableArea"
      >
        <template v-if="!isScopedSearch && Object.values(filterSets).length > 0">
          <single-filter :filter="filterSets"
            :key="'quick_filters'"
            :filterName="'quick_filters'"
            :isFilterLoaded="isFilterLoaded"
            :isFilterSetLoaded="isFilterSetLoaded"
            :state="state"
            :canViewFilters="canViewFilters"
            :canUseFilters="canUseFilters"
            class="mb-3"
            @filterCollapseToggled="handleCollapseToggled"
            @bucketToggled="handleBucketToggled"
            @setToggled="handleSetToggled"
            @bucketDateToggled="handleBucketDateToggled"
            @bucketSinceToggled="handleBucketSinceToggled"
            @bucketAdded="handleBucketAdded"
            @bucketShowAll="handleBucketShowAll"
          />
        </template>
        <template v-for="(filterSections, sectionName) in sectionedFilters">
          <div class="search_filters-sections" :key="sectionName">
            <span class="t-sm t-600">{{ sectionName | humanize }}</span>
            <a
              @click.prevent="toggleSection(sectionName)"
              class="t-xs pull-right t-secondary pr-3" href="#"
              v-if="canViewFilters"
            >{{ areAllFiltersInSectionOpen(filterSections) ? 'close' : 'open' }}</a>
            <template v-for="filter in filterSections">
              <single-filter
                v-if="!filter.hide"
                :filter="filter"
                :ref="filter.name"
                :key="filter.name"
                :filterName="filter.name"
                :isFilterLoaded="isFilterLoaded"
                :isFilterSetLoaded="isFilterSetLoaded"
                :state="state"
                :canViewFilters="canViewFilters"
                :canUseFilters="canUseFilters"
                :isHighlighted="highlightFilters.includes(filter.name)"
                @filterCollapseToggled="handleCollapseToggled"
                @bucketToggled="handleBucketToggled"
                @setToggled="handleSetToggled"
                @bucketDateToggled="handleBucketDateToggled"
                @bucketSinceToggled="handleBucketSinceToggled"
                @bucketAdded="handleBucketAdded"
                @bucketShowAll="handleBucketShowAll"
              />
            </template>
          </div>
        </template>
      </div>

      <!-- render spinner if not loaded -->
      <div v-if="!isInitSearchLoaded && !isFilterLoaded" class="card-body">
        <spinner :containerClass="`width--50px min-height--150px`" />
      </div>
    </div>
  </div>
</template>

<script>
import SingleFilter from '@/components/search/filter/Filter'
import Spinner from '@/components/shared/Spinner'
import sharedFilter from '@/mixins/search/filters'

export default {
  name: 'searchFilters',
  mixins: [sharedFilter],
  components: {
    SingleFilter,
    Spinner
  },
  data () {
    return {
      scrollToFilter: '',
      highlightFilters: [],
      localIndex: '',
      disableFilters: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.calculatePosition()
    })
  },
  watch: {
    isFilterLoaded (newVal, oldVal) {
      // Logic to make filters "inactive" when swapping indexes
      if (oldVal) {
        if (this.state.index !== this.localIndex) {
          this.disableFilters = true
        }
        this.localIndex = this.state.index
      }

      if (newVal) {
        this.localIndex = this.state.index
        this.disableFilters = false
        this.$nextTick(() => {
          const scrollToFilterName = this.state.scrollToFilter
          const filtersToHighlight = this.state.highlightFilters
          if (scrollToFilterName === 'top') {
            this.scrollToTop()
          } else if (scrollToFilterName) {
            this.scrollToFilter = scrollToFilterName
            this.scrollTo(scrollToFilterName)
          } else {
            this.scrollToFilter = ''
          }
          if (filtersToHighlight) {
            this.highlightFilters = filtersToHighlight
          } else {
            this.highlightFilters = []
          }

          // Clear the scrolled to filter in the main state, to prevent scrolling over and over when applying other filters/queries...
          this.$emit('clearSmartFilterEffects')
        })
      }
    }
  },
  methods: {
    scrollTo (filterName) {
      // Scroll to a particular filter
      const target = this.$refs[filterName]
      if (target && target[0] && target[0].$el) {
        // Get offset of relevant filter relative to parent div
        const offset = target[0].$el.offsetTop - 40
        // Scroll scrollable area of the filters, smoothly, to the desired filter
        this.$refs['scrollableArea'].scrollTo({
          top: offset,
          behavior: 'smooth'
        })
      }
    },
    scrollToTop () {
      this.$refs['scrollableArea'].scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    calculatePosition () {
      const footerHeight = 100
      const headerHeight = 79

      if (this.isStickySupported()) {
        // awesome: position:sticky is supported on this browser!
        this.$set(this.styles, 'max-height', `calc(100vh - ${headerHeight + footerHeight + 26}px)`)
        this.$set(this.styles, 'top', `100px`)
        this.$set(this.styles, 'position', `sticky`)
      } else {
        // fallback: I cannot rely on position:sticky!
        this.$set(this.styles, 'max-height', `calc(100vh - ${headerHeight + footerHeight}px)`)
        this.$set(this.styles, 'top', `0`)
        this.$set(this.styles, 'position', `relative`)
      }
    }
  }
}
</script>
